module.exports = __webpack_public_path__ + "img/img-001.4877981f.jpg";